export var SDK_VERSION = '6.17.9';
//# sourceMappingURL=version.js.map